// ASC Address
const ASC_ADDRESS = '0x9Fa63a24A63B6F90f2b46c41c9CF9bcf19dAC499'

export { ASC_ADDRESS }
